import { useState, useRef } from 'react'
import SlotApi from '../../../api/SlotApi';

const RankMemo = ({ slotId, content = '', callback = () => {} }) => {
    const [ memo, setMemo ] = useState(content);
    const [ isEdit, setIsEdit ] = useState(false);
    const memoInputRef = useRef(null);

    const handleMemoChg = e => {
        const { value } = e.target;
        if (value.length > 300) return alert('메모는 최대 300자까지 가능합니다.');
        setMemo(e.target.value);
    }

    const handleEditBtn = () => {
        setIsEdit(true);
        setTimeout(() => { 
            if (!memoInputRef.current) return;
            memoInputRef.current.focus(); 
            memoInputRef.current.setSelectionRange(memo.length, memo.length);
        }, 0)
    }

    const handleSaveBtn = async () => {
        if (memo.trim().length > 300) return alert('메모는 최대 300자까지 가능합니다.');
        setIsEdit(false);
        const rslt = await SlotApi.updateSlotMemo(slotId, memo);
        if (rslt.code == 'fail') {
            alert('메모 수정을 실패하였습니다.');
            setMemo(content);
        }  else {
            callback(memo);
        }
    }

    return (
        <div className="rank-result-menu">
            <label>메모</label>
            <input type="" name="" value={memo} onChange={handleMemoChg} placeholder="메모를 입력해주세요" />
            <button type="button" class="btn" onClick={handleSaveBtn}>
                <span>메모 수정</span>
            </button>
        </div>
    )
}

export default RankMemo;